import { ProductType, } from "@annunciate/core";
import { usePurchaseablesQuery } from "@annunciate/query";
export const usePurchaseables = (item) => {
    const { isPending, isError, data, } = usePurchaseablesQuery(item);
    const purchaseables = data?.purchaseables || [];
    const { authenticatedAccess, products, subscriptions, rentals } = purchaseables.reduce((acc, i) => {
        if (i.productType === ProductType.AUTHENTICATED) {
            acc.authenticatedAccess.push(i);
        }
        else if (i.productType === ProductType.ONETIME) {
            acc.products.push(i);
        }
        else if (i.productType === ProductType.RECURRING) {
            acc.subscriptions.push(i);
        }
        else if (i.productType === ProductType.RENTAL) {
            acc.rentals.push(i);
        }
        return acc;
    }, {
        authenticatedAccess: [],
        products: [],
        subscriptions: [],
        rentals: [],
    });
    return {
        isPending,
        isError,
        authenticatedAccess,
        products,
        subscriptions,
        rentals,
    };
};
//# sourceMappingURL=usePurchaseables.js.map